import {
    Grid,
    GridCellProps,
    GridColumn as Column,
    GridItemChangeEvent,
    GridPageChangeEvent,
    GridPagerSettings,
    GridRowProps,
    GridNoRecords
  } from "@progress/kendo-react-grid";import React from 'react';
  import { Icon } from "@iconify/react";


function AppliedJobsTable(Props: any) {


    const submittedOnCell = (props: GridCellProps) => {
        return (
            <td>
                {props.dataItem.submittedOn && new Date(parseInt(props.dataItem.submittedOn)).toDateString().slice(3)}
          </td>
      )
    }
    
    const jobRoleCell = (props: GridCellProps) => {
        return (
            <td>
                {props.dataItem.jobRole && props.dataItem.jobRole.name}
            </td>
        )
    }

    return (
      
        <div>
           <Grid
            data={Props.data}
            >
                <GridNoRecords>
                    <div className="noData">
                        <Icon icon="mdi:smiley-neutral-outline" />
                        No data to display
                    </div>
                </GridNoRecords>
                <Column field="position_name" title="Position" className="break-all" />    
                <Column field="jobRole" title="Job Role" className="break-all" cell={jobRoleCell} />    
                <Column field="company" title="Company" className="break-all" />    
                <Column field="current_stage" title="Position Status" className="break-all" />    
                <Column field="submittedOn" title="Submitted On" className="break-all" cell={submittedOnCell}/>    


             </Grid>    
        </div>
  )
}


export default AppliedJobsTable